import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { api, brl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const WARN_AT = 5;
const DAY = 86400000;

function bannerState(user) {
  if (!user || user.role === "admin") return null;
  if (user.subscription_status === "expired" && !(user.bonus_credits > 0)) return { ended: true, title: "Seu plano Profissional venceu", desc: "Renove para liberar mais 30 dias de análises ilimitadas.", cta: "Renovar" };
  if (user.plan_id === "pro" && user.plan_expires_at) {
    const days = Math.max(0, Math.ceil((new Date(user.plan_expires_at) - Date.now()) / DAY));
    if (days > WARN_AT) return null;
    return { ended: false, title: `Seu plano vence em ${days} ${days === 1 ? "dia" : "dias"}`, desc: "Renove agora e os novos 30 dias são somados ao período atual.", cta: "Renovar" };
  }
  const limit = user.plan?.analyses_per_month || 0;
  if (user.plan?.limit_period !== "total" || !limit) return null;
  const left = Math.max(0, limit - (user.usage || 0)) + (user.bonus_credits || 0);
  if (left > WARN_AT) return null;
  if (left === 0) return { ended: true, title: "Seu teste grátis terminou", desc: "Libere 30 dias de análises ilimitadas no plano Profissional.", cta: "Assinar" };
  return { ended: false, title: `Restam ${left} ${left === 1 ? "contestação" : "contestações"} do seu teste grátis`, desc: "Continue sem interrupção: análises ilimitadas no plano Profissional.", cta: "Assinar" };
}

export default function TrialBanner() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [price, setPrice] = useState(null);
  const [hidden, setHidden] = useState(false);
  const st = bannerState(user);
  const show = st && !(hidden && !st.ended);

  useEffect(() => {
    if (!show || price != null) return;
    api.get("/plans").then((r) => setPrice(r.data.find((p) => p.plan_id === "pro")?.price ?? null)).catch((e) => console.warn("plans load failed", e));
  }, [show, price]);

  if (!show) return null;

  return (
    <div data-testid="trial-banner" className={`fade-up relative mb-6 flex flex-col gap-3 rounded-2xl border p-4 sm:flex-row sm:items-center ${st.ended ? "border-amber-300 bg-amber-50" : "border-slate-200 bg-white"}`}>
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100"><Sparkles className="h-5 w-5 text-amber-600" /></span>
      <div className="flex-1">
        <p className="font-display font-bold text-slate-900" data-testid="trial-banner-title">{st.title}</p>
        <p className="text-sm text-slate-500">{st.desc}</p>
      </div>
      <button data-testid="trial-banner-subscribe-btn" onClick={() => nav("/configuracoes")} className="ai-cta inline-flex h-11 shrink-0 items-center justify-center gap-2 rounded-xl px-5 text-sm font-bold text-white">
        {st.cta}{price != null ? ` por ${brl(price)}` : ""}
      </button>
      {!st.ended && <button data-testid="trial-banner-dismiss" onClick={() => setHidden(true)} aria-label="Fechar aviso" className="absolute right-3 top-3 p-1 text-slate-400 hover:text-slate-700 sm:static"><X className="h-4 w-4" /></button>}
    </div>
  );
}
